import React from "react";
import { Outlet } from "react-router-dom";
import TopBar from "../../components/layout/topBar";
import Header from "../../components/layout/header";
import NavigationBar from "../../components/layout/navigationBar";
import { Box } from "@mui/material";
import { ChatProvider } from "../../components/common/chat/ChatProvider.jsx";
import Footer from "../../components/layout/Footer.jsx";
import "./index.css";

function MainLayout() {
  return (
    <Box
      id="layout"
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <NavigationBar />
      <Box>
        <ChatProvider>
          <Outlet />
        </ChatProvider>
      </Box>
      <Footer />
    </Box>
  );
}

export default MainLayout;
